import styled from 'styled-components';

export const PasswordChangeSC = styled.div`
  max-width: 808px;

  .ui-textfield,
  .ui-select,
  .ui-textarea {
    width: 100%;
  }

  .title {
    margin-bottom: ${({ theme }) => theme.spacings.text.XS}px;
  }
`;
